import React, { Component } from 'react';

import CheckinStatus from './CheckinStatus';
import OrganizationApi from '../../api/organization';
import PracticeApi from '../../api/practice';
import Select from 'react-select';
import Subnav from '../subnav';
import AuthService from '../../state/auth.service';

import withEhsPageBehavior from '../../withEhsPageBehavior';

const code = 'code';
const sortOptions = [
  { value: 'order', label: 'QPASS Order' },
  { value: code, label: 'Criteria ID' },
  { value: 'name', label: 'Criteria Title' },
  { value: 'scope', label: 'Scope' },
  { value: 'status', label: 'Status' },
  { value: 'type', label: 'Type' },
];

const PRACTICE_SORT_OPTION_KEY = 'EHS.PCMH.PRACTICE_SORT_OPTION_KEY';

class PracticeDashboardPage extends Component {
  constructor(props, context) {
    super(props, context);

    const defaultSortOption =
      localStorage.getItem(PRACTICE_SORT_OPTION_KEY) || code;

    this.state = {
      checkins: {},
      practiceOptions: [],
      sortByString: defaultSortOption,
    };
  }

  componentDidMount() {
    // todo - We're making 3 calls for this page. How about
    // a new endpoint that has everything we need (practice, checkins,
    // and org practices).
    const practiceId = this.props.match.params.practiceId;
    PracticeApi.getDetails(practiceId).then(practice => {
      this.setState({
        practice: practice,
      });

      AuthService.getUser();
      const userRole = AuthService.getUser();
      // If the user is a consultant or org admin, load the organization
      // practices for the practice select dropdown
      if (!userRole.resource.startsWith('practice:')) {
        OrganizationApi.getPractices(practice.organization_id)
          .then(practices => {
            let practiceOptions = [];
            practices.forEach(p => {
              practiceOptions.push({
                label: p.name,
                value: p.id,
              });
            });
            this.setState({
              practiceOptions: practiceOptions,
            });
          })
          .catch(err => {
            console.error(err);
          });
      }
    });

    PracticeApi.listCriteria(practiceId).then(checkins => {
      this.setState({ checkins });
    });
  }

  handlePracticeSort = ({ value }) => {
    // Update local storage
    localStorage.setItem(PRACTICE_SORT_OPTION_KEY, value);

    this.setState({
      sortByString: value,
    });
  };

  render() {
    let orgId = null;
    if (this.state.practice) {
      orgId = this.state.practice.organization_id;
    }

    let practiceSelect = null;
    if (this.state.practice && this.state.practiceOptions.length > 0) {
      practiceSelect = (
        <Select
          name="practices"
          options={this.state.practiceOptions}
          value={this.props.match.params.practiceId}
          onChange={e => {
            window.location.href = `./${e.value}`;
          }}
          clearable={false}
          searchable={false}
        />
      );
    } else if (this.state.practice) {
      practiceSelect = this.state.practice.name;
    }

    let primaryPracticeDesignator = null;
    if (this.state.practice && this.state.practice.primary_practice) {
      primaryPracticeDesignator = (
        <p className="primary">
          <i className="fa fa-hospital-o" /> Primary Practice
        </p>
      );
    }

    return (
      <main className="page">
        <div className="page__subnav">
          <Subnav
            practiceId={this.props.match.params.practiceId}
            organizationId={orgId}
          />
        </div>
        <div className="page__header">
          <h2>
            <i className="fa fa-stethoscope practice__icon" />
            {practiceSelect}
          </h2>
          <h2>
            <i className="fa fa-sort-amount-asc practice__icon"></i>
            <Select
              name="practice-sort"
              options={sortOptions}
              value={this.state.sortByString}
              onChange={this.handlePracticeSort}
              clearable={false}
              searchable={false}
            />
          </h2>
          <div className="HeaderMeta">{primaryPracticeDesignator}</div>
        </div>
        <div className="page__body">
          <CheckinStatus
            practiceId={this.props.match.params.practiceId}
            checkin={1}
            data={this.state.checkins['1']}
            sortByString={this.state.sortByString}
          />
          <CheckinStatus
            practiceId={this.props.match.params.practiceId}
            checkin={2}
            data={this.state.checkins['2']}
            sortByString={this.state.sortByString}
          />
          <CheckinStatus
            practiceId={this.props.match.params.practiceId}
            checkin={3}
            data={this.state.checkins['3']}
            sortByString={this.state.sortByString}
          />
        </div>
      </main>
    );
  }
}

export default withEhsPageBehavior(PracticeDashboardPage);
